import { useMemo } from 'react';
import { useNavigate as useOriginalNavigate, NavigateOptions } from 'react-router-dom';

import { PathnameEnum, PathParams } from './router.types';
import { generatePath } from './router.utils';

// @TODO update TS/babel config to let it handle template literal types
/* type SnakeToCamelCase<S extends string> = S extends `${infer T}_${infer U}`
  ? `${T}${Capitalize<SnakeToCamelCase<U>>}`
  : S;
type ProcessName<Name extends string> = `to${Capitalize<SnakeToCamelCase<Lowercase<Name>>>}`;

// https://github.com/microsoft/TypeScript/issues/50933
type EnumKeyLookup<Enum, Key extends keyof Enum, Value> = Key extends unknown
  ? Enum[Key] extends Value
    ? Key
    : never
  : never;
type PathnameKeyName<Value> = EnumKeyLookup<typeof PathnameEnum, keyof typeof PathnameEnum, Value>;

type NavigationMethods = {
  [Pathname in PathnameEnum as ProcessName<PathnameKeyName<Pathname>>]?: (
    ...[arg0, arg1]: Pathname extends keyof PathParams
      ? [PathParams[Pathname], NavigateOptions?]
      : [NavigateOptions?]
  ) => void;
}; */

export const useNavigate = () => {
  const navigate = useOriginalNavigate();

  return useMemo(() => {
    const methods = {
      toUserProfile: (params: PathParams[PathnameEnum.USER_PROFILE], options?: NavigateOptions) =>
        navigate(generatePath(PathnameEnum.USER_PROFILE, params), options),

      toConversationCompose: (options?: NavigateOptions) =>
        navigate(generatePath(PathnameEnum.CONVERSATION_COMPOSE), options),
      toConversationComposeGroup: (options?: NavigateOptions) =>
        navigate(generatePath(PathnameEnum.CONVERSATION_COMPOSE_GROUP), options),
      toConversationComposePrivate: (options?: NavigateOptions) =>
        navigate(generatePath(PathnameEnum.CONVERSATION_COMPOSE_PRIVATE), options),
      toConversationDetails: (
        params: PathParams[PathnameEnum.CONVERSATION_DETAILS],
        options?: NavigateOptions
      ) => navigate(generatePath(PathnameEnum.CONVERSATION_DETAILS, params), options),
      toConversationEdit: (
        params: PathParams[PathnameEnum.CONVERSATION_EDIT],
        options?: NavigateOptions
      ) => navigate(generatePath(PathnameEnum.CONVERSATION_EDIT, params), options),
      toConversationStart: (
        params: PathParams[PathnameEnum.CONVERSATION_START],
        options?: NavigateOptions
      ) => navigate(generatePath(PathnameEnum.CONVERSATION_START, params), options),
      toConversationRoot: (options?: NavigateOptions) =>
        navigate(generatePath(PathnameEnum.CONVERSATION_ROOT), options),
      toConversationSearch: (
        params: PathParams[PathnameEnum.CONVERSATION_SEARCH],
        options?: NavigateOptions
      ) => navigate(generatePath(PathnameEnum.CONVERSATION_SEARCH, params), options),
    };

    return methods;
  }, [navigate]);
};
